export interface GenericDataOutputResponse<T> {
  rows: T[];
  count: number;
}

export type Peminjaman = {
  id: string;
  tanggalPinjam: string;
  tanggalKembali: string;
  tanggalBatasKembali: string;
  perpanjang: boolean;
  lewat: number;
  penggunaId?: string;
  pengguna: Pengguna;
  koleksi: Koleksi;
  createdAt: string;
  updatedAt: string;
}

export type FAQTataTertib = {
  id?: string;
  title: string;
  description: string;
  order?: number;
};

export interface InfoTambahan {
  penerbit?: string;
  sumber?: string;
  cetakan?: string;
  edisi?: string;
  jilid?: string;
  isbn?: string;
  no_eks?: string;
  harga?: string;
  issn?: string;
  volume?: string;
  no_publikasi?: string;
  katalog_publikasi?: string;
  keterangan?: string;
  bulan_terbit?: string;
  kode_klasifikasi?: string;
  abstrak?: string;
  keyword?: string;
  pembimbing?: string;
  noInduk?: string;
}

export interface Koleksi {
  id?: string;
  noInduk: string;
  judul: string;
  penulis: string;
  tahunTerbit: string;
  kolasi: string;
  kodeRak: string;
  kodePanggil: string;
  jenisPustaka?: string;
  klasifikasi?: string;
  klasifikasiId?: string;
  tanggalMasuk: string;
  qrcode: string;
  createdAt?: string;
  updatedAt?: string;
  isDapatDibaca: boolean;
  isDapatDipinjam: boolean;
  jumlahDibaca: number;
  jumlahDisimpan: number;
  infoTambahan: InfoTambahan;
  coverFile?: string;
}

export interface NotifikasiReceipt {
  id: string;
  isRead: boolean;
  content: {
    id: string;
    type: string;
    title: string;
    body: string;
    date: string;
  };
}

export type ProfileData = {
  nama: string | null;
  kelas: string | null;
  noHp: string | null;
  foto: string | null;
  username: string;
  email: string;
  kunjungan: {
    waktuMasuk: string;
    loker: string | null;
    tas: string | null;
  } | null;
  kuotaBaca: {
    available: number;
    allowed: number;
    used: number;
    retryAfter: number;
  };
};
export type Pengguna = {
  id?: string;
  foto: string | null;
  username: string;
  email: string;
  role: string;
  nama: string;
  kelas: string;
  jenis_kelamin: string;
  no_hp: string;
  asal: string;
  pekerjaan: string;
  instansi: string;
  nik: string;
  in_perpus: boolean;
  createdAt: string;
};

export enum Role {
  INTERN = "intern",
  ADMIN = "admin",
  EKSTERN = "ekstern"
}

export const RoleLabels: Record<Role, string> = {
  [Role.INTERN]: "Mahasiswa dan Dosen",
  [Role.ADMIN]: "Admin",
  [Role.EKSTERN]: "Pengunjung Luar"
};

// const reasons = [
//   {
//     id: 'MEMBACA',
//     name: 'Membaca'
//   },
//   {
//     id: 'MEMINJAM_MENGEMBALIKAN',
//     name: 'Meminjam/Mengembalikan'
//   },
//   {
//     id: 'BELAJAR_DISKUSI',
//     name: 'Belajar/Diskusi'
//   },
//   {
//     id: 'LAINNYA',
//     name: 'Lainnya'
//   }
// ];

export enum TujuanKunjungan {
  MEMBACA = "MEMBACA",
  MEMINJAM_MENGEMBALIKAN = "MEMINJAM_MENGEMBALIKAN",
  BELAJAR_DISKUSI = "BELAJAR_DISKUSI",
  LAINNYA = "LAINNYA"
}

export const TujuanKunjunganLabels: Record<TujuanKunjungan, string> = {
  [TujuanKunjungan.MEMBACA]: "Membaca",
  [TujuanKunjungan.MEMINJAM_MENGEMBALIKAN]: "Meminjam/Mengembalikan",
  [TujuanKunjungan.BELAJAR_DISKUSI]: "Belajar/Diskusi",
  [TujuanKunjungan.LAINNYA]: "Lainnya"
};

export enum ToImprove {
  operasional = "operasional",
  kenyamanan = "kenyamanan",
  koleksi = "koleksi",
  simpus = "simpus",
  fasilitas = "fasilitas",
  informasi = "informasi",
  pelayanan = "pelayanan"
}

export const toImproveLabel: Record<string, string> = {
  [ToImprove.operasional]: "Jam Operasional",
  [ToImprove.kenyamanan]: "Kenyamanan",
  [ToImprove.koleksi]: "Kelengkapan Koleksi",
  [ToImprove.simpus]: "SIMPus",
  [ToImprove.fasilitas]: "Fasilitas",
  [ToImprove.informasi]: "Kelengkapan Informasi",
  [ToImprove.pelayanan]: "Pelayanan Petugas"
};

export enum JenisPustaka {
  SKRIPSI = "SKRIPSI",
  BUKU = "BUKU",
  JURNAL = "JURNAL",
  PUBLIKASI = "PUBLIKASI",
  MULTIMEDIA = "MULTIMEDIA",
  TERBITAN_BERKALA = "TERBITAN_BERKALA",
  KARYA_ILMIAH = "KARYA_ILMIAH",
  LAPORAN = "LAPORAN",
  EBOOK = "EBOOK",
  EJURNAL = "EJURNAL",
  JURNAL_INTERNASIONAL = "JURNAL_INTERNASIONAL"
}

export const jenisPustakaLabels: Record<JenisPustaka, string> = {
  [JenisPustaka.SKRIPSI]: "Skripsi",
  [JenisPustaka.BUKU]: "Buku",
  [JenisPustaka.JURNAL]: "Jurnal",
  [JenisPustaka.PUBLIKASI]: "Publikasi",
  [JenisPustaka.MULTIMEDIA]: "Multimedia",
  [JenisPustaka.TERBITAN_BERKALA]: "Terbitan Berkala",
  [JenisPustaka.KARYA_ILMIAH]: "Karya Ilmiah",
  [JenisPustaka.LAPORAN]: "Laporan",
  [JenisPustaka.EBOOK]: "Ebook",
  [JenisPustaka.EJURNAL]: "Ejurnal",
  [JenisPustaka.JURNAL_INTERNASIONAL]: "Jurnal Internasional"
};

export type Klasifikasi = {
  id: number;
  nama: string;
  _count: {
    koleksis: number;
  };
};

export type HariLibur = {
  id: string;
  tanggal: string;
  keterangan: string;
}

export enum StatusRekomendasi {
  DIAJUKAN = "DIAJUKAN",
  DITOLAK = "DITOLAK",
  DIPROSES = "DIPROSES",
  SELESAI = "SELESAI",
  DIBATALKAN = "DIBATALKAN"
}

export const statusRekomendasiLabels: Record<StatusRekomendasi, string> = {
  [StatusRekomendasi.DIAJUKAN]: "Diajukan",
  [StatusRekomendasi.DITOLAK]: "Ditolak",
  [StatusRekomendasi.DIPROSES]: "Diproses",
  [StatusRekomendasi.SELESAI]: "Selesai",
  [StatusRekomendasi.DIBATALKAN]: "Dibatalkan"
};

export interface Rekomendasi {
  id?: string;
  noInduk: string;
  title: string;
  topic: string;
  author: string;
  status: StatusRekomendasi;
  description: string;
  notes: string;
  createdAt: string;
  updatedAt: string;
  pengguna?: {
    id: string;
    nama: string;
    username: string;
  };
}
export type Pengunjung = {
  id: string;
  penggunaId?: string;
  username: string;
  foto: string | null;
  nama: string;
  waktuMasuk: string;
  waktuKeluar: string;
  statusKunci: boolean;
  nomorLoker: string;
  statusTas: boolean;
  nomorTas: string;
};

export type ExportData = {
  id: string;
  type: string;
  fileName: string;
  filePath: string;
  mimeType: string;
  createdAt: string;
  updatedAt: string;
}
